<template>
  <router-view />
</template>

<script>
export default {
  name: 'App',

  metaInfo: {
    title: 'Welcome',
    titleTemplate: '%s | Zion Ticket Portal',
  },
}
</script>
